<template>
    <v-container>
        <v-row class="no-gutters printbounds">
            <div class="text-left pad-labels">
                <div class="SpecimenID">
                    {{ loading ? 'LOADING' : value }}
                </div>
                <div>
                    <canvas ref="barcode" v-if="!error"></canvas>
                    <span v-else>{{ error }}</span>
                </div>
                <template v-if="specimenSet">
                    <div>
                        <span class="label">ARRIVAL:</span>
                        <span class="value" v-if="!loading">{{arrivalDateFormatted}}</span>
                    </div>
                    
                    <div>
                        <span class="label">GENDER:</span>
                        <span class="value" v-if="!loading">{{genderFull}}</span>
                    </div>
                    <div>
                        <span class="label">SOURCE:</span>
                        <span class="value" v-if="!loading">{{specimen.SupplierName}}</span>
                    </div>
                    <div>
                        <span class="label">ORIGIN:</span>
                        <span class="value" v-if="!loading">{{specimen.GeographicalLocationName}}</span>
                    </div>
                    <div>
                        <span class="label">VENOM TYPE(S):</span>
                        <span class="value" v-if="!loading">{{ venomTypeString }}</span>
                    </div>
                    
                    <div>
                        <span class="label">ARRIVAL WGT:</span>
                        <span class="value" v-if="!loading">{{arrivalWeight}} {{ arrivalDateFormatted }}</span>
                    </div>
                    <div>
                        <span class="label">CURRENT WGT:</span>
                        <span class="value" v-if="!loading">{{currentWeight}} {{ lastWeighDateFormatted }}</span>
                    </div>
                </template>
            </div>
            
            <div class="text-bold" v-if="specimenSet">
                WEIGHT HISTORY
                <table class="weightHistory" v-if="!loading">
                    <tr v-for="item in adjustedWeightHistory" :key="item.id">
                        <td>
                            {{ item.weight }}
                        </td>
                        <td>
                            {{ item.unit }}
                        </td>
                        <td>
                            {{ item.date }} 
                        </td>
                    </tr>
                </table>
            </div>
        </v-row>
    </v-container>
</template>

<script type="text/javascript">
import bwipjs from 'bwip-js';
import constants from 'comunet-btg-utah-repository-shared/constants';

import moment from 'moment';

export default {
    components: {

    },
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        'value',
        //eslint-disable-next-line
        'specimen',
        //eslint-disable-next-line
        'specimenVenom',
        //eslint-disable-next-line
        'venomTypes',
        //eslint-disable-next-line
        'loading'
    ],
    data() {
        return {
            error: null
        };
    },
    watch: {
        value(){
            this.drawBarcode(this.value);
        }
    },
    computed: {
        venomTypeString() {
            var venomNameString = "";
            if(this.specimenSet && !this.specimenVenom){
                return "n/a"
            }
            for (let i = 0; i < this.specimenVenom.length; i++) {
                const venom = this.venomTypes.find(x => x.VenomTypeID == this.specimenVenom[i].VenomTypeID);
                if(venom === undefined) {
                    continue;
                }
                venomNameString += venomNameString.length > 0 ? ', ' : ' '
                venomNameString += venom.VenomTypeName
            }
            return venomNameString;
        },
        arrivalWeight() {
            if(this.specimenSet && this.specimen.WeightHistory != undefined){
                var firstWeight = this.specimen.WeightHistory[this.specimen.WeightHistory.length-1];
                if (isNaN(parseInt(firstWeight.Weight))) {
                    return firstWeight.Weight;
                }
                return parseInt(firstWeight.Weight) + ' gms';
            }
            return null;
        },
        currentWeight() {
            var currentWeightStr = "";
            if(this.specimenSet && this.specimen.WeightHistory != undefined){
                var current = this.specimen.WeightHistory[0];
                if (isNaN(parseInt(current.Weight))) {
                    currentWeightStr = current.Weight;
                }
                // weight in grams as a string
                currentWeightStr = parseInt(current.Weight) + ' gms';
            }

            return currentWeightStr;
        },
        arrivalDateFormatted() {
            return moment(this.specimen.ArrivalDate).format(constants.DATE_FORMAT_NO_TIME);
        },
        lastWeighDateFormatted() {
            // The total number of records to show, this includes the current and arrival
            if (this.specimen == undefined || this.specimen.WeightHistory == undefined){
                return "";
            }
            // if there are only 2 weight history records, the last weight date was the arrival date
            if(this.specimen.WeightHistory.length <= 2){
                return moment(this.specimen.ArrivalDate).format(constants.DATE_FORMAT_NO_TIME);
            }
            else {
                // check if date follows YYYY-MM-DD format
                // eslint-disable-next-line no-useless-escape
                var dateRegex = new RegExp (/[0-9]{4}[\-\/][0-9]{2}[\-\/][0-9]{2}/)
                var lastWeighDateStr = this.specimen.WeightHistory[1].HusbandryDate
                if (dateRegex.test(lastWeighDateStr)){
                    //valid date, return it formatted
                    var date = moment(lastWeighDateStr);
                    return date.format(constants.DATE_FORMAT_NO_TIME);
                } else {
                    // not a valid date, return it unchanged
                    return lastWeighDateStr;
                }
            }

        },
        genderFull() {
            if (this.specimen.Gender == "M") {
                return "Male";
            }
            else if (this.specimen.Gender == "F") {
                return "Female";
            }

            return "";
        },
        adjustedWeightHistory(){
            // The total number of records to show, this includes the current and arrival
            if (this.specimen == undefined || this.specimen.WeightHistory == undefined){
                return [];
            }
            var records = this.specimen.WeightHistory.filter(wh => !wh.HusbandryDate.includes("Weight"))

            // check if date follows YYYY-MM-DD format
            // eslint-disable-next-line no-useless-escape
            var dateRegex = new RegExp (/[0-9]{4}[\-\/][0-9]{2}[\-\/][0-9]{2}/)

            return records.map(x => {

                var date = moment(x.HusbandryDate);
                var dateString = "";
                var unitStr = "";
                var weightVal;
                if (dateRegex.test(x.HusbandryDate)){
                    dateString = date.format(constants.DATE_FORMAT_NO_TIME);
                } else {
                    dateString = x.HusbandryDate;
                }

                if(!isNaN(parseInt(x.Weight))){
                    unitStr = "gms"
                    weightVal = parseInt(x.Weight)
                }
                else {
                    weightVal = x.Weight
                }
                
                return {
                    id: x.ID,
                    date: dateString,
                    unit: unitStr,
                    weight : weightVal
                };
            });
        },
        specimenSet() {
            return this.specimen;
        }
    },
    methods: {
        drawBarcode(value){
            let that = this;
            bwipjs(this.$refs.barcode, {
                bcid: 'code128',
                text: value,
                width: 60,
                height: 10,
                includetext: false,
                textxalign: 'center'
            }, function(error){
                that.error = error;
            });
        }
    },
    mounted() {
        this.drawBarcode(this.value);
    }
};
</script>

<style lang="scss">
@media print {
    @page {
        margin: 0 !important;  /* this affects the margin in the printer settings */
    }

    html{
        background: #fff;
        margin: 0px;  /* this affects the margin on the html before sending to printer */
    }

    body{
        margin: 0mm; /* margin you want for the content */
    }
    .v-main {
        background-color: #fff !important;
    }
}

.printbounds {
    width: 90mm;
    line-height: initial;
    font-size: 14pt;
    font-weight: bold;

     .left-col {
        width: 42mm;

        > div {
            padding-bottom: 2mm
        }
     }
     .right-col {
        width: 47mm;
     }
     .pad-labels {
        width: 100%;
        .label {
            padding-right: 5mm;
        }
     }

     .left-col > div, 
     .pad-labels > div {
        padding-bottom: 2mm;
     }
}

.weightHistory tr {
    td:nth-child(1) {
        padding-right: 5px
    }
    td:nth-child(2) {
        width: 14mm;
    }
    td:nth-child(3) {
        padding-left: 5px
    }
}

.SpecimenID {
    font-size: 30pt;
    font-weight: 700;
}

</style>
